import React from 'react';
import ReactTooltip from 'react-tooltip';

const ColumnHeader = ({
    title,
    tooltip
}) => {
    return (
        <>
            <ReactTooltip id={`column-header-${title}`} type='light' className='tool-tip'>
                <span>{tooltip}</span>
            </ReactTooltip>
            <div data-tip data-for={`column-header-${title}`}>
                {title}
            </div>
        </>
    );
}

export default ColumnHeader;
